<template lang="pug">
.dashboard-card
  .section-header
    .section-title
      h2 Nuevos empleados
  //- CONTENEDOR CON SCROLL
  .employees-scroll(
    ref="employeesScroll"
    @scroll.passive="handleScroll"
  )
    //- CARGA INICIAL
    .initial-loading(
      v-if="isLoading && lista.length === 0"
    )
      span.loader
      span Cargando empleados...
    //- SIN INFORMACIÓN
    .empty-state(
      v-else-if="!isLoading && lista.length === 0"
    )
      .empty-icon
        i.fa.fa-users
      .empty-info
        strong No hay empleados nuevos
        span No se encontraron nuevas incorporaciones.
    //- LISTADO
    template(v-else)
      .employee(
        v-for="(empleado, index) in lista"
        :key="empleado.id || empleado.numeroDocumento || index"
      )
        .employee-avatar
          | {{ empleado.usuario }}
        .employee-info
          strong
            | {{ empleado.nombre }}

          span.employee-position
            | {{ empleado.cargo || 'Sin cargo registrado' }}

          span.employee-area
            | {{ empleado.area || 'Sin área registrada' }}

        .employee-entry
          small Fecha de ingreso

          strong
            | {{ empleado.fechaIngreso }}

      //- CARGANDO SIGUIENTE PÁGINA
      .scroll-loading(v-if="isScroll")
        span.loader.loader-small
        span Cargando más empleados...

      //- FIN DE LA INFORMACIÓN
      .scroll-end(
        v-if="noMore && lista.length > 0"
      )
        span No hay más empleados nuevos

</template>
<script>
import { apiGet, notify }  from '../../../util/general'
export default {
  name: 'NuevosEmpleados',
  data () {
    return {
      lista: [],
      numeroRecnum: 0,
      noMore: false,
      disabledScrollExecute: false,
      isScroll: false,
      isLoading: false
    }
  },
  mounted () {
    this.obtenerNuevoEmpleado(false)
  },
  methods: {
    handleScroll (event) {
      var element = event.target
      if (this.isLoading || this.isScroll || this.noMore || this.disabledScrollExecute) {
        return
      }
      var scrollTop = element.scrollTop
      var scrollHeight = element.scrollHeight
      var clientHeight = element.clientHeight
      /*
       * Carga cuando faltan aproximadamente
       * 80px para llegar al final.
       */
      var distanciaFinal =
        scrollHeight - (scrollTop + clientHeight)
      if (distanciaFinal <= 80) {
        this.obtenerNuevoEmpleado(true)
      }
    },
    obtenerNuevoEmpleado (esScroll) {
      var vm = this
      if (vm.noMore || vm.disabledScrollExecute) {
        return
      }
      vm.disabledScrollExecute = true
      if (esScroll) {
        vm.isScroll = true
      } else {
        vm.isLoading = true
      }
      var obj = {
        numeroRecnum: vm.numeroRecnum
      }
      apiGet(vm, '/empleado/obtenerNuevoEmpleado', obj, function (data) {
        console.log('data.lista >>>>>>', data.lista)
        var lista = data && data.lista ? data.lista : []
        for (var i = 0; i < lista.length; i++) {
          vm.lista.push(lista[i])
        }
        if (data.noMore) {
          vm.noMore = true
          vm.disabledScrollExecute = true
        } else {
          vm.numeroRecnum += data.numeroRecnum
          vm.disabledScrollExecute = false
        }
      }, function (error) {
        vm.disabledScrollExecute = false
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isScroll = false
        vm.isLoading = false
      })
    }
  }
}
</script>
<style scoped>
.dashboard-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background: #fff;
  border: 1px solid #e4e6eb;
  border-radius: 10px;
  overflow: hidden;
}
.section-header {
  padding: 11px 21px;
  border-bottom: 1px solid #eff0f2;
}
.section-title h2 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
  color: #292d32;
}
.section-title p {
  margin: 4px 0 0;
  font-size: 12px;
  color: #8b9097;
}
.card-header {
  min-height: 65px;
  padding: 15px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  border-bottom: 1px solid #eef0f2;
}
.card-title h3 {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #292d32;
}
.card-title p {
  margin: 4px 0 0;
  font-size: 10px;
  color: #9499a0;
}
.employees-scroll {
  flex: 1;
  max-height: 245px;
  min-height: 245px;
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: #c9cbd0 transparent;
}
.employees-scroll::-webkit-scrollbar {
  width: 5px;
}
.employees-scroll::-webkit-scrollbar-track {
  background: transparent;
}
.employees-scroll::-webkit-scrollbar-thumb {
  background: #c9cbd0;
  border-radius: 10px;
}
.employees-scroll::-webkit-scrollbar-thumb:hover {
  background: #aeb1b7;
}
.employee {
  min-height: 76px;
  padding: 12px 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f0f1f3;
  cursor: pointer;
  transition: background .15s ease;
}
.employee:last-of-type {
  border-bottom: 0;
}
.employee:hover {
  background: #faf9fa;
}
.employee-avatar {
  width: 42px;
  height: 42px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f0e8ed;
  color: #714b67;
  font-size: 11px;
  font-weight: 700;
}
.employee-info {
  flex: 1;
  min-width: 0;
  margin-left: 13px;
  display: flex;
  flex-direction: column;
}
.employee-info strong {
  font-size: 11px;
  color: #34383d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.employee-position {
  margin-top: 3px;
  font-size: 10px;
  color: #747a81;
}
.employee-area {
  margin-top: 2px;
  font-size: 9px;
  color: #a2a6ac;
}
.employee-entry {
  margin-left: 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  flex-shrink: 0;
}
.employee-entry small {
  font-size: 8px;
  color: #a1a5ab;
}
.employee-entry strong {
  margin-top: 3px;
  font-size: 9px;
  color: #4e5358;
}
.empty-state {
  min-height: 245px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 25px;
}
.empty-icon {
  width: 52px;
  height: 52px;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #f4f0f3;
  color: #714b67;
  font-size: 19px;
}
.empty-info {
  display: flex;
  flex-direction: column;
}
.empty-info strong {
  font-size: 12px;
  color: #41464c;
}
.empty-info span {
  margin-top: 5px;
  font-size: 10px;
  color: #979ca2;
}
.initial-loading {
  min-height: 245px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 10px;
  color: #93989e;
}
.scroll-loading {
  min-height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  color: #90959b;
  font-size: 9px;
}
/* LOADER */
.loader {
  width: 23px;
  height: 23px;
  border: 2px solid #eee;
  border-top-color: #714b67;
  border-radius: 50%;
  animation: spin .7s linear infinite;
}
.loader-small {
  width: 15px;
  height: 15px;
}
@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}
.scroll-end {
  min-height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #f2f2f2;
  background: #fafafa;
  color: #a0a4aa;
  font-size: 9px;
}
</style>



// WEBPACK FOOTER //
// c_nuevos_empleados.vue?6d2a8cc0